import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tooltip from 'li-components/lib/next/Tooltip'
import vars from 'li-components/lib/styles'

import { getAppDotOrigin, tourName, track } from '../../util'
import config from '../../config'
import AppLink from './AppLink'

const getCursor = p => (p.isAccessRestricted ? 'not-allowed' : 'pointer')

export const TooltipLink = styled(Tooltip)`
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  font-weight: 700;
  cursor: ${getCursor};
  transition: background-color 0.2s;

  .AppLink {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  &:hover {
    background-color: ${vars.grayLighter};

    .AppLink a {
      color: ${vars.gray};
      cursor: ${getCursor};
    }
  }

  a:not('.marketingLink') {
    cursor: ${getCursor};
  }
`

const P = styled.p`
  a {
    display: block;
    margin-top: 2rem;
    color: ${vars.brandPrimary};
    pointer-events: auto !important;

    &:hover {
      color: ${vars.brandPrimary};
    }
  }
`

const origin = getAppDotOrigin()

const PlatformNavLink = (
  { id, href, isAuthorized, onClickAppLink, tooltipPosition },
  { appId }
) => {
  const info = config.applicationConfigurations[id]

  return (
    <TooltipLink
      position={tooltipPosition}
      popperOptions={PlatformNavLink.popperOptions}
      title={
        isAuthorized
          ? null
          : `${id[0].toUpperCase() + id.slice(1)} - Premium Feature`
      }
      className="TooltipLink"
      isAccessRestricted={!isAuthorized}
      interactive
      html={
        isAuthorized ? (
          <P>{info.description}</P>
        ) : (
          <P>
            {info.marketingDescription}
            <a
              className="marketingLink"
              href={
                info.marketingLink ||
                config.applicationConfigurations.default.marketingLink
              }
              onClick={() => {
                track({ event: 'appLinkMarketingLinkClick', label: id })
              }}
            >
              Learn More
            </a>
          </P>
        )
      }
    >
      <AppLink
        id={id}
        href={href || (appId === id ? `/${appId}` : `${origin}/${id}`)}
        text={id}
        onClick={e => {
          if (onClickAppLink) {
            onClickAppLink(e)
          } else if (!isAuthorized) {
            e.preventDefault()
            track({ event: 'appLinkClick', label: id })
          }
        }}
        data-tour={tourName(`applink-${id}`)}
      />
    </TooltipLink>
  )
}

PlatformNavLink.popperOptions = {
  modifiers: {
    hide: {
      enabled: false,
    },
    preventOverflow: {
      enabled: false,
    },
    flip: {
      enabled: false,
    },
  },
}

PlatformNavLink.propTypes = {
  id: PropTypes.string.isRequired,
  href: PropTypes.string,
  isAuthorized: PropTypes.bool.isRequired,
  onClickAppLink: PropTypes.func,
  tooltipPosition: PropTypes.string.isRequired,
}

PlatformNavLink.contextTypes = {
  appId: PropTypes.string.isRequired,
}

export default PlatformNavLink



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/PlatformNavLink.js